// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__NtV-k","Title":"style_Title__Jn_6S","Body":"style_Body__1xsKB","Button":"style_Button__1c89V"};